import styled from 'styled-components';
import { unthemed } from 'tokens';

export const AccessSection = styled.div`
	margin-bottom: 24px;
`;

export const ToggleContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

interface ToggleButtonProps {
	selected: boolean;
	disabled?: boolean;
}

export const ToggleButton = styled.button<ToggleButtonProps>`
	display: flex;
	align-items: center;
	width: 100%;
	padding: 12px 16px;
	border: 2px solid ${({ theme, selected }) => (selected ? theme.blue[500] : theme.gray[200])};
	border-radius: 8px;
	background-color: ${({ theme, selected }) => (selected ? theme.blue[300] : theme.gray[0])};
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	transition: all 0.2s ease;
	opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

	&:hover:not(:disabled) {
		border-color: ${({ theme, selected }) => (selected ? theme.blue[600] : theme.gray[400])};
		background-color: ${({ theme, selected }) =>
			selected ? theme.blue[300] : theme.gray[100]};
	}

	&:focus {
		outline: none;
		box-shadow: 0 0 0 2px ${({ theme }) => theme.blue[300]};
	}
`;

export const ToggleButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	width: 100%;
`;

export const ToggleButtonIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`;

export const ToggleButtonText = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[1000]};
	line-height: 1.4;
	text-align: left;
`;

export const LoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: 24px;
`;

export const LoadingText = styled.p`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const LinkSection = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	width: 100%;
`;

export const LinkButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 6px;

	background: ${({ theme }) => theme.blue[500]};
	&:hover {
		background-color: #006dd4;
	}
	&:active {
		background: #0060cc;
	}
	border: 1px solid ${({ theme }) => theme.blue[700]};
	padding: 8px;
	padding-right: 12px;
	padding-left: 12px;
	border-radius: 20px;
`;

export const Link = styled.div`
	color: ${unthemed.gray['0']};
	display: flex;
	gap: 8px;
	font-size: 12px;
	font-weight: 500;
	background: transparent;
`;

export const AccessInformation = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const ManageLinksContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-top: 16px;
`;

export const ManageLink = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	padding: 0;
	font-size: 13px;
	text-decoration: underline;
	color: ${({ theme }) => theme.gray[1000]};
	text-align: left;

	&:hover {
		color: ${({ theme }) => theme.gray[800]};
	}

	&:focus {
		outline: none;
	}
`;
